module.exports = __webpack_public_path__ + "static/img_cta-3-826ece5a034ae3e685adf7ab65125791.svg";